( function( $ ) {
    'use strict';

    $( function() {
        var hoverClass = 'is-hover';
        var activeClass = 'is-active';
        var $body = $( 'body' );
        var $submenuBody = $( '.js-submenu-body' );

        $( '.js-submenu-trigger' ).on( 'click', function( event ) {
        	event.preventDefault();
        	console.log( 'clicked' );

        	$( this ).parent().find( $submenuBody ).addClass( 'is-active' );
        } );

	    $( '.js-dropdown-trigger' ).on( {
		    mouseenter: function() {
			    $body.addClass( hoverClass );
		    },
		    mouseleave: function() {
			    $body.removeClass( hoverClass );
			    $submenuBody.removeClass( activeClass );
		    }
	    } );
    } );
} )( jQuery );
